import { IEmbeddedAttachment } from '@shared/models/proto/base/chat'

export const isFormSubmission = (payload?: IEmbeddedAttachment['payload']) => {
  if (!payload) {
    return
  }

  return payload.case === 'formSubmission'
}
